import _regeneratorRuntime from "@babel/runtime/regenerator";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import 'url-polyfill';
import ReactDOM from 'react-dom';
import React from 'react';
import dva, { connect } from 'dva';
import 'abort-controller/polyfill'; // import { createBrowserHistory as createHistory } from 'history';

import createLoading from 'dva-loading';
import 'moment/locale/zh-cn';
import 'moment/locale/en-gb';
import { useEffect } from 'react';
import intl from "hzero-front/lib/utils/intl";
import { persistMenuTabs } from "hzero-front/lib/utils/menuTab";
import * as serviceWorker from "../serviceWorker";
import { getConfig, getConfigStore, overWriteConfig } from "../index";
var updateLayout = function updateLayout(props) {
  var container = props.container ? props.container.querySelector('#root') || props.container : document.getElementById('root');
  if (props.hideLayout !== undefined) {
    if (props.hideLayout) {
      container.classList.add('qiankun-hide-hzero-layout');
    } else {
      container.classList.remove('qiankun-hide-hzero-layout');
    }
  }
  if (props.hideTabs !== undefined) {
    if (props.hideTabs) {
      container.classList.add('qiankun-hide-hzero-layout-tabs');
    } else {
      container.classList.remove('qiankun-hide-hzero-layout-tabs');
    }
  }
};
var getHzeroAppApi = function getHzeroAppApi() {
  return {
    dvaApp: window['dvaApp'],
    menuTabs: require("hzero-front/lib/utils/menuTab"),
    intl: intl,
    window: window
  };
}; // let isMounted = false;

var mount = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var props,
      container,
      globalConfig,
      createHistory,
      basePath,
      browserHistoryBuildOptions,
      myHistory,
      dvaOption,
      dvaOptionConfig,
      app,
      oldLayoutExtraHeader,
      GetTabsChangeHooks,
      globalConfigStore,
      dvaAppInitHook,
      globalModal,
      ERR_COUNT_SESSION_KEY,
      dealGlobalError,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            dealGlobalError = function _dealGlobalError(error) {
              console.error(error);
              if (process.env.NODE_ENV === 'production') {
                var globalExceptionHistory = JSON.parse(localStorage.getItem('hzero-global-exception-history') || '[]');
                globalExceptionHistory.push({
                  errorMessage: error && error.message,
                  errorLocation: window.location.href,
                  error: error
                });
                if (globalExceptionHistory.length > 10) {
                  globalExceptionHistory.shift();
                }
                localStorage.setItem('hzero-global-exception-history', JSON.stringify(globalExceptionHistory));
                app._store.dispatch({
                  type: 'error/updateState',
                  payload: {
                    globalException: {
                      history: globalExceptionHistory
                    }
                  }
                });
                if ((error === null || error === void 0 ? void 0 : error.filename) && error.message && (error === null || error === void 0 ? void 0 : error.message.includes('Uncaught SyntaxError')) && (error === null || error === void 0 ? void 0 : error.type) === 'error') {
                  // TODO: 捕获到 错误后 刷新页面
                  var errCount = Number(sessionStorage.getItem(ERR_COUNT_SESSION_KEY)) || 0;
                  sessionStorage.setItem(ERR_COUNT_SESSION_KEY, "".concat(errCount + 1));
                  if (errCount < 1) {
                    window.location.reload();
                  }
                }
              }
            };
            props = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
            // qiankun相关
            updateLayout(props);
            container = props.container ? props.container.querySelector('#root') : document.getElementById('root');
            if (props.container) {
              props.container['getHzeroAppApi'] = getHzeroAppApi;
            } // if(props.keepAlive && window['dvaApp']) {
            //   window['dvaApp'].start(container);
            //   return;
            // }
            // 预先加载样式 在打包子模块的时候不需要再对样式进行处理,提高打包性能

            require("../index.less");
            require("./all-ui-styles");
            require("./registerApi");
            require('hzero-boot-customize-init-config'); // 通过别名实现对config的修改功能 此时@global-config指向工作目录

            globalConfig = require('@global-config');
            overWriteConfig(globalConfig);
            if (globalConfig.default) {
              overWriteConfig(globalConfig.default);
            }
            createHistory = require('history').createBrowserHistory;
            basePath = process.env.BASE_PATH || '/'; // ReactDOM.render(<App />, document.getElementById('root'));
            // If you want your app to work offline and load faster, you can change
            // unregister() to register() below. Note this comes with some pitfalls.
            // Learn more about service workers: http://bit.ly/CRA-PWA

            browserHistoryBuildOptions = {};
            if (basePath !== '/') {
              browserHistoryBuildOptions.basename = basePath;
            }
            myHistory = createHistory(browserHistoryBuildOptions);
            dvaOption = {
              history: myHistory
            };
            dvaOptionConfig = getConfig('dvaOption');
            if (typeof dvaOptionConfig === 'function') {
              dvaOption = dvaOptionConfig(dvaOption);
            } else if (dvaOption) {
              dvaOption = _objectSpread(_objectSpread({}, dvaOption), dvaOptionConfig);
            } // 1. Initialize

            app = dva(dvaOption); // 1.1 attach dva app to window
            // 挂载到window上可以通过
            // dvaApp._store.getState().global.routerData 查看路由表

            window.dvaApp = app; // qiankun相关的内容

            if (props.onTabsChange) {
              oldLayoutExtraHeader = getConfig('layoutExtraHeader');
              GetTabsChangeHooks = connect(function (_ref2) {
                var global = _ref2.global;
                return {
                  tabs: global.tabs,
                  activeTabKey: global.activeTabKey
                };
              })(function (_ref3) {
                var tabs = _ref3.tabs,
                  activeTabKey = _ref3.activeTabKey;
                useEffect(function () {
                  tabs.forEach(function (item) {
                    item.intlTitle = item.title ? intl.get(item.title) || item.title : item.title;
                  });
                  props.onTabsChange({
                    tabs: tabs,
                    activeTabKey: activeTabKey
                  }, {
                    intl: intl
                  });
                });
                var _extraHeaderRight = React.useMemo(function () {
                  if (!oldLayoutExtraHeader) {
                    return undefined;
                  }
                  if (Array.isArray(oldLayoutExtraHeader)) {
                    return /*#__PURE__*/React.createElement(React.Fragment, null, oldLayoutExtraHeader.map(function (com) {
                      return React.isValidElement(com) ? com : React.createElement(com);
                    }));
                  } else if (React.isValidElement(oldLayoutExtraHeader)) {
                    return oldLayoutExtraHeader;
                  } else {
                    return React.createElement(oldLayoutExtraHeader);
                  }
                }, []);
                if (!_extraHeaderRight) {
                  return false;
                }
                return _extraHeaderRight;
              });
              overWriteConfig({
                layoutExtraHeader: GetTabsChangeHooks
              });
            }
            globalConfigStore = getConfigStore();
            if (globalConfigStore.initC7nUiConfig) {
              globalConfigStore.initC7nUiConfig();
            }
            dvaAppInitHook = getConfig('dvaAppInit');
            if (dvaAppInitHook) {
              dvaAppInitHook(app);
            } // 2. Plugins

            app.use(createLoading());
            globalModal = getConfig('globalModal'); // 3. Register global model

            app.model(globalModal(app));
            app.model(require('hzero-front/lib/models/user').default); // 4. Router
            // @ts-nocheck

            app.router(getConfig('dvaRootRouter')()); // const { initIoc }  = require( "hzero-front/lib/utils/iocUtils" );
            // initIoc();
            // app.router((() => {
            //   return (
            //     <div>xx</div>
            //   );
            // }) as Router);
            // 5. Start

            app.start(container); // isMounted = true;

            if (process.env.NOT_SAVE_TABS_INFO !== 'true') {
              window.addEventListener('beforeunload', persistMenuTabs); // 存储 tab 信息
            }

            ERR_COUNT_SESSION_KEY = '_error_count';
            /**
             * 全局错误处理
             * @param {Error} error - 错误
             */

            setTimeout(function () {
              sessionStorage.removeItem(ERR_COUNT_SESSION_KEY);
            }, 5000);
            if (process.env.NODE_ENV !== 'development') {
              // 只有在非开发模式下才监听全局错误
              // 开发模式 webpack-dev 会自动将错误的显示出来
              window.addEventListener('error', getConfig('dealGlobalError') || dealGlobalError);
            }
            serviceWorker.unregister();
          case 38:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function mount() {
    return _ref.apply(this, arguments);
  };
}();
var unmount = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(props) {
    var app, container;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            app = window.dvaApp;
            container = props.container ? props.container.querySelector('#root') || props.container : document.getElementById('root');
            ReactDOM.unmountComponentAtNode(container); // if(props.keepAlive && app) {
            //   return;
            // }

            app._models.forEach(function (model) {
              app.unmodel(model.namespace);
            });
            container.classList.remove('qiankun-hide-hzero-layout');
            container.classList.remove('qiankun-hide-hzero-layout-tabs');
          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function unmount(_x) {
    return _ref4.apply(this, arguments);
  };
}();
var bootstrap = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(props) {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (window.__INJECTED_PUBLIC_PATH_BY_QIANKUN__) {
              window.CKEDITOR_BASEPATH = window.__INJECTED_PUBLIC_PATH_BY_QIANKUN__ + 'lib/ckeditor/';
            }
          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return function bootstrap(_x2) {
    return _ref5.apply(this, arguments);
  };
}();
/**
 * 可选生命周期钩子，仅使用 loadMicroApp 方式加载微应用时生效
 */

function update(_x3) {
  return _update.apply(this, arguments);
}
function _update() {
  _update = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(props) {
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            updateLayout(props);
          case 1:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _update.apply(this, arguments);
}
bootstrap.getHzeroAppApi = getHzeroAppApi;
export { mount, unmount, bootstrap, update, getHzeroAppApi };